import { ChangeEvent } from "react"

interface SelectFilterProps {
  value: string
  onChange: (value: string) => void
  children: React.ReactNode
  placeholder?: boolean
}

export function SelectFilter({ value, onChange, children, placeholder = false }: SelectFilterProps) {
  return (
    <select
      value={value}
      onChange={(e: ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
      style={{
        height: "40px",
        border: "1px solid #E2E8F0",
        borderRadius: "8px",
        padding: "0 36px 0 10px",
        fontSize: "0.875rem",
        color: placeholder && !value ? "#718096" : "#4A5568",
        background: `white url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'%3E%3Cpath fill='%23718096' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E") no-repeat right 10px center`,
        appearance: "none",
        WebkitAppearance: "none",
        cursor: "pointer",
      }}
    >
      {children}
    </select>
  )
}
